export class ApiError extends Error {
  constructor(message, { status = null, cause = null } = {}) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.cause = cause;
  }
}

export const normalizeApiError = (error) => {
  if (error instanceof ApiError) return error;

  const status = error?.response?.status ?? null;
  const message = status
    ? "The server could not complete the request."
    : "The service is temporarily unavailable.";

  return new ApiError(message, { status, cause: error });
};
